import { createContext, useContext, useState, useCallback } from "react";

const HelpPanelContext = createContext(null);

export function HelpPanelProvider({ children }) {
  const [state, setState] = useState({
    open: false,
    guideId: null,
    sectionId: null,
  });

  const openGuide = useCallback((guideId, sectionId = null) => {
    setState({ open: true, guideId, sectionId });
  }, []);

  const closePanel = useCallback(() => {
    setState((prev) => ({ ...prev, open: false }));
  }, []);

  const minimizePanel = useCallback(() => {
    setState((prev) => ({ ...prev, minimized: !prev.minimized }));
  }, []);

  return (
    <HelpPanelContext.Provider
      value={{ ...state, openGuide, closePanel, minimizePanel }}
    >
      {children}
    </HelpPanelContext.Provider>
  );
}

export function useHelpPanel() {
  const ctx = useContext(HelpPanelContext);
  if (!ctx)
    throw new Error("useHelpPanel must be used within HelpPanelProvider");
  return ctx;
}
